const JS_APP_LINK = "https://nauk.in/KJU29LxR";
export const waBroadCastMessageTemplates = [
  {
    id: "1",
    name: "Job Invite template",
    template: `We have an exciting job opportunity for you.
  
  Job Details
  
  💼 Job Title: {{job_title}}
  🏤 Company Name : {{company_name}} 
  📌 Location: {{address}} 
  💰 Salary : {{salary}} 
  👉 Check job details on Job Hai app and explore more opportunities!

  ${JS_APP_LINK}

  Reply 'Yes' to this message to know more
  
  Best Regards,  
  {{full_name}}
  `
  },
  {
    id: "2",
    name: "Request Call Back template",
    template: `We tried reaching out to you. But could not speak with you.  
  Kindly call back on this number {{phone}} 
  to discuss an exciting job opportunity for you.  
     
  Job Details
  
  💼 Job Title: {{job_title}}
  🏤 Company Name : {{company_name}} 
  📌 Location: {{address}} 
  💰 Salary : {{salary}}          
  👉 Check job details on Job Hai app and explore more opportunities!

  ${JS_APP_LINK}
  
  Reply 'No' if this job is not relevant  
     
  Best Regards,  
  {{full_name}}`
  },
  {
    id: "3",
    name: "Ask for resume template",
    template: `I found your profile on JobHai. I am urgently hiring for the below job:
  
  Job Details
  
  💼 Job Title: {{job_title}}
  🏤 Company Name : {{company_name}} 
  📌 Location: {{address}} 
  💰 Salary : {{salary}}   
  👉 Check job details on Job Hai app and explore more opportunities!
    
  ${JS_APP_LINK}

  I think you could be a great fit for this role!    
  
  If you're interested in learning more about this opportunity, give me a call back on this number:    
  
  We can also connect on Whatsapp if you have any questions. 
     
  Best Regards,  
  {{full_name}}`
  },
  {
    id: "4",
    name: "Invite for walk-in template",
    template: `Congratulations! 🎉 You are selected for interview. Please confirm your availability
   
  Walkin Details
  
  📅 Date : {{Please add walkin date}} 
  🕚 Time : {{Please add Time}} 
  📌 Location : {{address}}
  👉 Check job details on Job Hai app and explore more opportunities!
    
  ${JS_APP_LINK}  
  
Thanks,  
{{full_name}}`
  },
  {
    id: "5",
    name: "Interview reminder template",
    template: `This is a gentle reminder for your upcoming interview with us.
  
  Interview Details
  
  📅 Date : {{Please add interview Date, eg.14th June}}
  🕚 Time : {{Please add interview Time, eg. 11:30 pm}}
  📌 Location : {{address}}   
  👉 Check job details on Job Hai app and explore more opportunities!
    
  ${JS_APP_LINK} 

  All the best!👍  
  {{full_name}}`
  },
  {
    id: "6",
    name: "Intent Qualification Template",
    template: `Hello,
  
  Thank you for applying for the position! To confirm your interest and help us proceed further:
  
  Job Details

  💼 Job Title: {{job_title}}
  🏤 Company Name : {{company_name}} 
  📌 Location: {{address}} 
  💰 Salary : {{salary}}   
  👉 Check job details on Job Hai app and explore more opportunities!
    
  ${JS_APP_LINK} 

  Please reply ‘Yes’ if you are interested in this opportunity or ‘No’ if not.
  
  Looking forward to your response!
  
  Best Regards,
{{full_name}} 
  `
  },
  {
    id: "7",
    name: "Competency Qualification Template",
    template: `Hi,
  
  We are reviewing profiles for an exciting job opportunity and wanted to check if you meet the following requirements:
  
  Job Details

  💼 Job Title: {{job_title}}
  🏤 Company Name : {{company_name}} 
  📌 Location: {{address}} 
  💰 Salary : {{salary}}   
  👉 Check job details on Job Hai app and explore more opportunities!
    
  ${JS_APP_LINK} 

  Qualification Requirements
  
  Do you have {{skill/asset, e.g., a 2-wheeler and valid driver’s license}}?
  
  Are you comfortable with {{specific requirement, e.g., night shifts}}?
  
  Reply ‘Yes’ if you meet the above qualifications, or reply ‘No’ if this isn’t relevant to you.
  
  Best Regards,
  {{full_name}}`
  }
];

export const waBroadCastExtensionId = "ieacglkkmemcenknbponnlnfgbolmoca";

export const WHATSAPP_BROADCAST_POPUP_STOPPED =
  "whatsapp_broadcast_popup_stopped";
export const WHATSAPP_BROADCAST_POPUP_TYPE = "whatsapp_broadcast";

export const WHATSAPP_BROADCAST_EXTENSION_LINK =
  "https://chromewebstore.google.com/detail/wa-quick-recruit-by-job-h/ieacglkkmemcenknbponnlnfgbolmoca";
